const locale = {
  'commodityList.message.enterOE': 'يرجى إدخال رقم OE',
  'commodityList.message.addSuccess':
    'تم إضافة المنتجات إلى السلة بنجاح، يمكنك الذهاب إلى السلة للتحقق',
  'commodityList.message.fetchProductsSuccess': 'تم البحث بنجاح',
  'commodityList.message.placeholderOENumber': `يمكن استعلام ما يصل إلى 1000 رقم OE في المرة الواحدة؛ افصل بين إدخالات متعددة بأسطر، مثال:
000001
000002
000003`,
  'commodityList.text.AllTotal': 'تم العثور على {total} نتيجة لك',
  'commodityList.text.groupTotal': 'تم العثور على {total} نتيجة',
  'commodityList.button.search': 'بحث',
  'commodityList.button.reset': 'إعادة تعيين',
  'commodityList.title.accessoriesDetails': 'تفاصيل الملحقات',
  'commodityList.title.replacementNumber': 'رقم الاستبدال',
  'commodityList.title.storeName': 'المتجر',
  'commodityList.title.availabilityAndLeadTime': 'التوفر والوقت المتوقع',
  'commodityList.title.price': 'السعر',
  'commodityList.title.operation': 'العملية',
  'commodityList.message.selectProduct': 'يرجى تحديد المنتجات المراد إضافتها',
  'commodityList.text.selectedProducts': 'تم تحديد {count} منتج ({quantity} قطعة)،',
  'commodityList.text.total': 'المجموع:',
  'commodityList.button.batchAddToCart': 'إضافة إلى السلة',
  'commodityList.message.maxDataLimit': 'تجاوز 2000 عنصر، سيتم البحث في أول 2000 فقط',
  'commodityList.message.noImportData': 'لا توجد بيانات للاستيراد',
  'commodityList.message.batchQueryLoading': 'جاري البحث الدفعي...',
  'commodityList.message.noProductData': 'لا توجد بيانات للمنتجات',
  'commodityList.message.settleSuccess': 'تم حفظ التسوية بنجاح',
  'commodityList.message.orderFailed': 'فشل الطلب، يرجى المحاولة لاحقًا',
  'commodityList.button.orderNow': 'اطلب الآن',
  'commodityList.import.oeNumber': 'رقم القطعة',
  'commodityList.import.brand': 'العلامة التجارية', // 配件品牌
  'commodityList.import.quantity': 'الكمية',
  'commodityList.import.rule1': '1. يدعم فقط ملفات .xlsx.',
  'commodityList.import.rule2':
    '2. بعد الرفع يمكنك إضافة أو تحديث القائمة دفعة واحدة. يوضح الجدول أدناه الحقول القابلة للاستيراد، * تعني إلزامي.',
  'commodityList.button.batchImport': 'استيراد دفعة',
  'commodityList.text.supportBatchQuery': 'يدعم البحث الدفعي عن أرقام OE والتعبئة التلقائية للكمية',

  'commodityList.import.downloadTemplateUrl':
    'https://fe-static.cassmall.com/assets/applications/20250715163719/Import Template.xlsx',

  'commodityList.message.invalidData': 'بعض كميات البضائع لا تفي بالمتطلبات، يرجى التأكد',

  'commodity.multiple-sale.error.minSaleCount': 'كمية الشراء لا يمكن أن تكون أقل من أقل كمية مبيعة',
  'commodity.multiple-sale.error.multipleSaleCount':
    'كمية الشراء يجب أن تكون مضاعفة لكمية المبيعات المتعددة',
  total_match_found: '{total} نتيجة مطابقة',
  total_Item_selected: '{total} عنصر محدد',
  Total_colon_total: 'المجموع: {total}',
  Request_a_quote: 'طلب عرض سعر',
  Coming_soon: 'قريبا',
  Place_order: 'طلب الآن',
  Specifications: 'المواصفات',
  Pack_Size: 'حجم العبوة',
  total_pcs_case: '{total} pcs/case',
  MOQ: 'MOQ',
  total_pcs: '{total} pcs',
  In_stock: 'في المخزن',
  Backorder: 'في الخلف',
  Immediate: 'فوري',
  total_Found: '{total} موجود',
  total_Unfound: '{total} غير موجود',
  Availability_and_Lead_Time_Tip:
    'وقت التسليم هو الفترة من وضع الطلب إلى عندما يكون البضائع جاهزة للشحن.',
  Supported_Manufacturers: 'المصنعين المدعومين',
};

export default locale;
